import React from "react";

function DropRight({ width = 24, height = 25, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_112_44181)">
        <path d="M10 17L15 12L10 7V17Z" fill={fill} />
      </g>
    </svg>
  );
}

export default DropRight;
